module.exports = __webpack_public_path__ + "static/media/29COICT7.581384eb.jpg";